/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetReportsIncomeBreakdownParamsSource = typeof GetReportsIncomeBreakdownParamsSource[keyof typeof GetReportsIncomeBreakdownParamsSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportsIncomeBreakdownParamsSource = {
  GetReportsIncomeBreakdownParamsSourceEvents: 'events',
  GetReportsIncomeBreakdownParamsSourceNonProgramLines: 'non_program_lines',
} as const;
